import { render, staticRenderFns } from "./LiquidacionProrrateoIndex.vue?vue&type=template&id=455b2a4c"
import script from "./LiquidacionProrrateoIndex.vue?vue&type=script&lang=js"
export * from "./LiquidacionProrrateoIndex.vue?vue&type=script&lang=js"
import style0 from "./LiquidacionProrrateoIndex.vue?vue&type=style&index=0&id=455b2a4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports